enum OrganizationType {
  Legal = 'LEGAL',
  Individual = 'INDIVIDUAL',
}

export default OrganizationType
